import { BrowserRouter, Switch, Route } from "react-router-dom";
import { HomePage } from "./pages/Home";
import { NewsList } from "./pages/news/NewsList";
import { NewsDetail } from "./pages/news/NewsDetail";
import { DataList } from "./pages/datas/DataList";
import { TechList } from "./pages/techs/TechList";
import { Sensor } from "./pages/sensor";
import { About } from "./pages/about";
// import { RightMenu } from "./components/rightmenu/RightMenu";
// import { RichText } from "./components/richtext";
import { Recruite } from "./pages/recruite";
import { Resource } from "./pages/resource";
import { Contacts } from "./pages/contact/Contacts";
import 'antd/dist/antd.min.css';
import { ConfigProvider } from "antd";
import zhCN from "antd/es/locale/zh_CN";

const App = () => (
  <ConfigProvider locale={zhCN}>
    <div>
      {/* <BrowserRouter basename="/estar-official"> */}
      <BrowserRouter>
        <Switch>
          <Route path="/" exact component={HomePage} />
          <Route path="/news" exact component={NewsList} />
          <Route path="/datas" exact component={DataList} />
          <Route path="/techs" exact component={TechList} />
          <Route path="/sensor" exact component={Sensor} />
          <Route path="/about" exact component={About} />
          <Route path="/detail" exact component={NewsDetail} />
          <Route path="/recruite" exact component={Recruite} />
          <Route path="/resource" exact component={Resource} />
          <Route path="/contacts" exact component={Contacts} />
        </Switch>
      </BrowserRouter>
    </div>
  </ConfigProvider>
);

export default App;
